/**
 * Algerian dinar.
 */
export var DZD = {
  code: 'DZD',
  base: 10,
  exponent: 2
};